/* eslint-disable max-len */

import {get, set, cloneDeep} from 'lodash';
import {
  RESET,
  GET_SUMMARY_REPORT_REQUEST,
  GET_SUMMARY_REPORT_SUCCESS,
  GET_SUMMARY_REPORT_FAIL,
  GET_DRIVER_REPORT_REQUEST,
  GET_DRIVER_REPORT_SUCCESS,
  GET_DRIVER_REPORT_FAIL,
  GET_DETAILS_REPORT_REQUEST,
  GET_DETAILS_REPORT_SUCCESS,
  GET_DETAILS_REPORT_FAIL,
  DOWNLOAD_REPORT_REQUEST,
  DOWNLOAD_REPORT_SUCCESS,
  DOWNLOAD_REPORT_FAIL
} from './ReportActionsType';

const initialState = {
  report: {
    list: [],
    totals: {
      coached: 0,
      medias: 0,
      reviewCompleted: 0,
      reviewed: 0,
      unreviewed: 0,
      tagged: 0,
      severity1: 0,
      severity2: 0,
      recognition: 0,
      primary: 0,
      secondary: 0
    },
    page: 0,
    pages: 0,
    hasMorePages: false,
    isLoading: false,
    isDownloadLoading: false
  }
};

export default function report(state = initialState, action) {
  const type = get(action, 'type');
  const newState = cloneDeep(state);
  switch (type) {
    case GET_SUMMARY_REPORT_REQUEST:
      set(newState, 'report.isLoading', true);
      set(newState, 'report.list', []);
      set(newState, 'report.totals', initialState.report.totals);
      return {
        ...newState
      };
    case GET_SUMMARY_REPORT_SUCCESS:
      set(newState, 'report.isLoading', false);
      set(newState, 'report.list', get(action, 'payload.report.data.data', []));
      set(newState, 'report.totals', get(action, 'payload.report.data.totals', initialState.report.totals));
      return {
        ...newState
      };
    case GET_SUMMARY_REPORT_FAIL:
      set(newState, 'report.isLoading', false);
      return {
        ...newState
      };
    case GET_DRIVER_REPORT_REQUEST:
      set(newState, 'report.isLoading', true);
      set(newState, 'report.list', []);
      set(newState, 'report.totals', initialState.report.totals);
      return {
        ...newState
      };
    case GET_DRIVER_REPORT_SUCCESS:
      set(newState, 'report.isLoading', false);
      set(newState, 'report.list', get(action, 'payload.report.data.data', []));
      set(newState, 'report.totals', get(action, 'payload.report.data.totals', initialState.report.totals));
      return {
        ...newState
      };
    case GET_DRIVER_REPORT_FAIL:
      set(newState, 'report.isLoading', false);
      return {
        ...newState
      };
    case GET_DETAILS_REPORT_REQUEST:
      set(newState, 'report.isLoading', true);
      set(newState, 'report.list', []);
      set(newState, 'report.totals', initialState.report.totals);
      return {
        ...newState
      };
    case GET_DETAILS_REPORT_SUCCESS:
      set(newState, 'report.isLoading', false);
      set(newState, 'report.list', get(action, 'payload.report.data', []));
      set(newState, 'report.totals', initialState.report.totals);
      return {
        ...newState
      };
    case GET_DETAILS_REPORT_FAIL:
      set(newState, 'report.isLoading', false);
      return {
        ...newState
      };
    case DOWNLOAD_REPORT_REQUEST:
      set(newState, 'report.isDownloadLoading', true);
      return {
        ...newState
      };
    case DOWNLOAD_REPORT_SUCCESS:
      set(newState, 'report.isDownloadLoading', false);
      return {
        ...newState
      };
    case DOWNLOAD_REPORT_FAIL:
      set(newState, 'report.isDownloadLoading', false);
      return {
        ...newState
      };
    case RESET:
      return {
        ...newState,
        ...initialState
      };
    default:
      return newState;
  }
}
